export const FlipbookImageTagger = 'flipbook-image-tagger';
export const FlipbookVideoUpload = 'flipbook-video-upload';
